module.exports = __webpack_public_path__ + "img/20200116155349360截图20200116113941926.8846bc28.jpg";